import jump from "jump.js";
import Gator from "gator";

Gator(document.documentElement).on("click", ".scroll-downs", () => {
    jump(".js-scroll-content", {
        offset: -70
    });
});
